import React, { useState } from "react";
import axios from "../api/axios";

const AboutUsPanel = () => {
  const [file, setFile] = useState(null);
  const [message, setMessage] = useState("");

  const handleUpload = async () => {
    if (!file) {
      setMessage("Selecciona un archivo Word (.docx) para subir.");
      return;
    }
    try {
      const formData = new FormData();
      formData.append("file", file);
      const { data } = await axios.post("/about/upload", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setMessage(data.message);
    } catch (error) {
      console.error("Error subiendo About Us:", error);
      setMessage("Error al subir el archivo.");
    }
  };

  return (
    <div className="flex">
      <div className="flex-1 ml-64 p-6 bg-gray-100 min-h-screen">
        <h1 className="text-3xl font-bold mb-6 text-center">Actualizar "Sobre Nosotros"</h1>
        {message && (
          <div className="mb-4 p-3 bg-green-100 border-l-4 border-green-500 text-green-700">
            {message}
          </div>
        )}
        <div className="bg-white shadow-lg rounded-lg p-6 border border-blue-600 w-full max-w-md mx-auto">
          <input
            type="file"
            accept=".docx"
            onChange={(e) => setFile(e.target.files[0])}
            className="mb-4"
          />
          <button
            onClick={handleUpload}
            className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          >
            Subir Archivo
          </button>
        </div>
      </div>
    </div>
  );
};

export default AboutUsPanel;
